<div class="card testimonial-card">
    <div class="card-body">
        <div class="row">
            <div class="col-12 text-center">
                <span class="large-quote float-left">"</span>
                <ngb-rating [rate]="testimonial.rating">
                </ngb-rating>
            </div>

            <div class="col-12 card-text">
                <p>
                    {{testimonial.quote}}
                </p>
            </div>
            <br>
            <div class="col-12 card-text">
                <div class="row">
                    <div class="col-12 font-600">{{testimonial.user}}</div>
                    <div class="col-12 font-600">{{testimonial.designation}}</div>
                    <div class="col-12 font-600">{{testimonial.hospital}}</div>
                </div>
            </div>
        </div>
    </div>
</div>